<template>
  <div>
    <div class="row justify-content-end">
      <div class="col-auto">
        <button
          class="btn btn-secondary"
          @click="$router.push({ name: 'productions-items-edit' })"
        >
          <i class="bi bi-file-earmark-plus fs-4"></i>
          Modifier les articles
        </button>
      </div>
    </div>
    <div class="row">
      <div class="col-xl-3 col-12">
        <label for=""> Charge </label>

        <vue-select :options="rawMaterials" v-model="production.rawMaterial_reference" labelColumn="date"
          valueColumn="reference" />
      </div>

      <div class="col-3">
        <label for=""> Date</label>
        <input type="date" v-model="production.date" class="form-control" />
      </div> 

      <div class="col-3">
        <label for=""> Nombre de Plt Entier</label>
        <input type="text" v-model="production.quantityUnit" class="form-control" />
      </div> 
      
      <div class="col">
        <label for=""> Remarque </label>
        <textarea
          rows="1"
          v-model="production.remark"
          class="form-control"
        ></textarea>
      </div>
    </div>
    <br />

    <div class="row mt-3 justify-content-between">
      <div class="col-auto"></div>
      <div class="col-auto">
        <button class="btn btn-success" @click="save(production)">
          <i class="bi bi-check-square-fill"></i> Enregistrer
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  data() {
    return {
      
    };
  },
  computed: {
    ...mapGetters("rawMaterial", {
      rawMaterials: "getAll",
    }),

     ...mapGetters("production", {
      production: "getProduction",
    }),
  },
  methods: {
    async save(data) {
      await this.$store.dispatch("production/update", data);
    },
  },
  async beforeMount() {
      await this.$store.dispatch("rawMaterial/getAll");
      await this.$store.dispatch("production/show", this.$route.params.reference);
  },
};
</script>
